import THEMES, { type ThemeMeta, type ThemeName } from "./themes"

const THEME_LOCAL_STORAGE_KEY = "color"
const THEME_ATTRIBUTE = "data-theme"
const THEME_BRIGHTNESS_ATTRIBUTE = "data-brightness"

export interface ThemeValue {
	name: ThemeName
	isRedesign: boolean
	theme: string
	background: string
	color: string
}

const getDefaultTheme = () => THEMES[0]

export const saveTheme = (theme: ThemeMeta) => {
	localStorage.setItem(THEME_LOCAL_STORAGE_KEY, theme.name)
}

export const getThemeDefinition = (name: ThemeName): ThemeMeta => THEMES.find((theme) => theme.name === name) ?? THEMES[0]

export const getSelectedThemeName = () => {
	const name = localStorage.getItem(THEME_LOCAL_STORAGE_KEY) as ThemeName

	return getThemeDefinition(name || getDefaultTheme().name).name
}

/**
 * Applies theme styling, does not interact with local storage
 */
export const applyTheme = (name: ThemeName): ThemeMeta => {
	const theme = getThemeDefinition(name)
	const root = document.documentElement

	root.setAttribute(THEME_ATTRIBUTE, theme.name)
	root.setAttribute(THEME_BRIGHTNESS_ATTRIBUTE, theme.brightness)

	return theme
}

export const initializeTheme = (): ThemeMeta => {
	const themeName = getSelectedThemeName()
	const theme = getThemeDefinition(themeName)

	// Reset theme if its invalid
	if (localStorage.getItem(THEME_LOCAL_STORAGE_KEY) !== themeName) {
		saveTheme(theme)
	}

	return applyTheme(theme.name)
}
